// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"map_iconSync__3CmHx","fa-spin":"map_fa-spin__2hpGp"};